import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading w-100 d-flex justify-center align-center"
}
const _hoisted_2 = { class: "max-w-md w-full space-y-8" }
const _hoisted_3 = {
  key: 1,
  class: "error-message w-100 d-flex justify-center align-center"
}

import { ref } from 'vue';
import VLoaderAnimation from '@/components/template/v-loader-animation.vue';
import InfoWindowContents from '@/components/VehicleInstall/InfoWindowContents.vue';
import i18n from '@/lang/i18n';
import VehicleTimedPosition from '@/types/VehicleTimedPosition';
import getVehicleResponse from '@/types/responses/getVehicle';
import { safeCenterCoordinates } from '@/services/consts';


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleMap',
  props: {
    vehiclePosition: {},
    vehicleInfo: {},
    zoomLevel: {},
    isMarkerVisible: { type: Boolean },
    isLoadingFinished: { type: Boolean },
    errorMessage: {}
  },
  setup(__props: any) {

const props = __props;

const isInfoWindowOpen = ref(false);
const infoWindowContents = ref<InstanceType<typeof InfoWindowContents> | null>(null);

function handleInfoWindowClose() {
  isInfoWindowOpen.value = false;
  if (infoWindowContents.value) {
    infoWindowContents.value.clearVehicleAddress();
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_GMapInfoWindow = _resolveComponent("GMapInfoWindow")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-map-marker", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t('pages.vehicleInstall.map.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!props.isLoadingFinished)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(VLoaderAnimation, {
                text: 'text-black',
                "loading-text": _unref(i18n).global.t('pages.vehicleInstall.map.waitingLocationInfo'),
                "loading-text-style": 'text-black text-lg',
                addCharacterImg: false
              }, null, 8, ["loading-text"])
            ])
          ]))
        : _createCommentVNode("", true),
      (props.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_alert, {
              type: "error",
              class: "col-8"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.errorMessage), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_GMapMap, {
        center: props.vehiclePosition?.position ?? _unref(safeCenterCoordinates),
        zoom: props.zoomLevel,
        "map-type-id": "roadmap"
      }, {
        default: _withCtx(() => [
          (props.isMarkerVisible && props.vehiclePosition)
            ? (_openBlock(), _createBlock(_component_GMapMarker, {
                key: 0,
                position: props.vehiclePosition?.position ?? _unref(safeCenterCoordinates),
                clickable: true,
                draggable: false,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isInfoWindowOpen.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_GMapInfoWindow, {
                    closeclick: true,
                    opened: isInfoWindowOpen.value,
                    onCloseclick: handleInfoWindowClose
                  }, {
                    default: _withCtx(() => [
                      _createVNode(InfoWindowContents, {
                        ref_key: "infoWindowContents",
                        ref: infoWindowContents,
                        vehicleInfo: __props.vehicleInfo,
                        vehiclePosition: __props.vehiclePosition
                      }, null, 8, ["vehicleInfo", "vehiclePosition"])
                    ]),
                    _: 1
                  }, 8, ["opened"])
                ]),
                _: 1
              }, 8, ["position"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["center", "zoom"])
    ]),
    _: 1
  }))
}
}

})